<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4.15913,9.00151C4.15913,9.00151,0.977648,9.00151,0.977648,9.00151C0.439942,9.00151,0,8.53214,0,7.99432C0,7.45651,0.439942,7.00412,0.977648,7.00412C0.977648,7.00412,4.15714,7.00412,4.15714,7.00412C4.569,5.83677,5.68453,5,6.99606,5C8.3076,5,9.42313,5.83677,9.83499,7.00412C9.83499,7.00412,12.8147,7.00412,12.8147,7.00412C11.917,6.248279999999999,11.411,5.81149,11.2967,5.69375C11.1252,5.5171399999999995,11.0039,5.26241,11.0039,4.988613C11.0039,4.450798,11.4581,4,11.9958,4C12.2695,4,12.5173,4.108119,12.6933,4.29391C12.8106,4.41777,13.8151,5.42308,15.7067,7.30983C15.8827,7.48584,16,7.7205200000000005,16,7.99432C16,8.26812,15.8925,8.51258,15.7165,8.68859C15.7165,8.68859,12.6981,11.71642,12.6981,11.71642C12.5221,11.89244,12.2777,12,12.0039,12C11.4509,12,11.0039,11.55264,11.0039,11.01482C11.0039,10.741019999999999,11.1207,10.47014,11.2967,10.29412C11.2967,10.29412,12.8147,9.00151,12.8147,9.00151C12.8147,9.00151,9.83299,9.00151,9.83299,9.00151C9.41954,10.16591,8.30549,11,6.99606,11C5.68664,11,4.57258,10.16591,4.15913,9.00151C4.15913,9.00151,4.15913,9.00151,4.15913,9.00151Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FlowLinear',
} as DefineComponent
</script>
